/**
 * @file 分账号列表
 */
<template>
  <div class="p-account-management">
    <div class="p-account-management__condition">
      <div class="p-account-add__btn">
        <plv-button @click="handleToAddAccount">新建分账号</plv-button>
      </div>
      <div>
        <plv-condition-filter v-model="conditionValue" @search="handleSearch">
          <plv-condition-filter-item
            prop="memo"
            label="分账号备注："
            type="input"
            placeholder="请输入备注"
          />
          <plv-condition-filter-item
            prop="email"
            label="分账号邮箱："
            type="input"
            placeholder="请输入分账号邮箱"
          />
          <plv-condition-filter-item type="search" />
        </plv-condition-filter>
      </div>
    </div>
    <div class="p-account-management-table">
      <plv-table
        v-loading="loading"
        :data.sync="dataSource.contents"
        :row-key="rowData => rowData.unionId"
        :multiple-select-max-count="selectAccountMaxLimitCount"
      >
        <plv-table-column
          width="80px"
          title="选择"
          type="multiple"
          :multiple-value.sync="selectUnionIds"
          :multiple-disabled="({rowData}) => needDsiabledSelect({rowData})"
        />
        <plv-table-column title="分账号邮箱" prop="email" />
        <plv-table-column title="备注" prop="memo" />
        <plv-table-column title="剩余金额（元）" prop="balance">
          <template slot-scope="scope">
            <span>{{ scope.rowData.balance | decimalFormat }}</span>
          </template>
        </plv-table-column>
        <plv-table-column title="云直播计费类型" prop="billType">
          <template slot-scope="scope">
            {{ scope.rowData.chargeTypeDesc }}
          </template>
        </plv-table-column>
        <plv-table-column title="云直播剩余资源">
          <template slot-scope="scope">
            {{ scope.rowData.chargeType === chargeTypeEnum.Minutes ? `${scope.rowData.remainMinutes} 分钟` :
              `${scope.rowData.remainConcurrent} 并发` }}
          </template>
        </plv-table-column>
        <plv-table-column title="已用频道数">
          <template slot-scope="scope">
            {{ scope.rowData.usedChannels }}/{{ scope.rowData.maxChannels }}
          </template>
        </plv-table-column>
        <plv-table-column width="200px" title="素材库剩余资源" prop="materialResources">
          <template slot-scope="scope">
            <div class="p-account-management-table__vod">
              <span class="p-account-management-table__vod__item">流量: {{ scope.rowData.avalableMaterialTraffic | vodUnit }}</span>
              <span>空间: {{ scope.rowData.avalableMaterialSpace | vodUnit }}</span>
            </div>
          </template>
        </plv-table-column>
        <plv-table-column width="200px" title="云点播剩余资源" prop="vodResources">
          <template slot-scope="scope">
            <div class="p-account-management-table__vod">
              <span class="p-account-management-table__vod__item">流量: {{ scope.rowData.remainFlow | vodUnit }}</span>
              <span>空间: {{ scope.rowData.remainSpace | vodUnit }}</span>
            </div>
          </template>
        </plv-table-column>
        <plv-table-column width="200px" title="云点播总资源" prop="vodTotalResources">
          <template slot-scope="scope">
            <div class="p-account-management-table__vod">
              <span class="p-account-management-table__vod__item">流量: {{ scope.rowData.totalTraffic | vodUnit }}</span>
              <span>空间: {{ scope.rowData.totalSpace | vodUnit }}</span>
            </div>
          </template>
        </plv-table-column>
        <plv-table-column title="账号到期时间" prop="expireDate">
          <span slot-scope="scope">
            {{ scope.rowData.expireType === 'group' ? '跟随主账号' : scope.rowData.expireDate | formatDate('yyyy-MM-dd') }}
          </span>
        </plv-table-column>
        <plv-table-column title="状态" prop="status">
          <div slot-scope="scope" class="p-account-operate">
            <span>{{ status[scope.rowData.status] }}</span>
          </div>
        </plv-table-column>
        <plv-table-column title="操作" prop="status">
          <div slot-scope="scope" class="p-account-operate">
            <span class="p-account-operate__detail" @click="handleSubAccountDetail(scope.rowData)">查看</span>
            <span
              v-if="scope.rowData.status === statusEnum.Normal || scope.rowData.status === statusEnum.Frozen"
              class="p-account-operate__status"
              @click="handleStatusChange(scope.rowData)"
            >
              {{ scope.rowData.status === statusEnum.Normal ? '冻结' : '解冻' }}
            </span>
          </div>
        </plv-table-column>
      </plv-table>
      <div v-if="dataSource.contents.length" class="p-account-management__pagination-wrapper">
        <div class="p-account-management__pagination-wrapper__left">
          <div>
            已选 {{ selectUnionIds.length }} / {{ selectAccountMaxLimitCount }} 个
          </div>
          <plv-button
            type="operate"
            class="plv-ml-16"
            :disabled="!selectUnionIds.length"
            @click="openSettingDialog"
          >
            批量管理设置
          </plv-button>
        </div>
        <plv-pagination
          v-model="dataSource.pageNumber"
          class="plv-mt-20"
          align="right"
          :total="dataSource.totalPages"
          :page-size.sync="dataSource.pageSize"
          @currentChange="handlePageChange"
          @pageSizeChange="handlePageChange"
        />
      </div>
    </div>

    <!-- 批量管理设置弹窗 -->
    <account-setting-dialog
      ref="settingDialog"
      @confirm="toSaveAccountSetting"
    />
  </div>
</template>

<script>
import { chargeType, chargeTypeEnum, status, statusEnum } from '@/utils/type';
import AccountSettingDialog from './components/account-setting-dialog.vue';

export default {
  components: {
    AccountSettingDialog
  },
  data() {
    return {
      chargeType,
      chargeTypeEnum,
      status,
      statusEnum,
      selectUnionIds: [],
      selectAccountMaxLimitCount: 100,
      dataSource: {
        contents: [],
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1,
        totalItems: 100
      },
      conditionValue: {
        email: '',
        memo: ''
      },
      loading: false,
    };
  },
  created() {
    this.getSubAccountList();
  },
  methods: {
    /** 需要禁用商品可选逻辑 */
    needDsiabledSelect({ rowData }) {
      return this.selectUnionIds.length >= this.selectAccountMaxLimitCount ? !this.selectUnionIds.includes(rowData.unionId) : false;
    },
    handleSubAccountDetail(detailInfo) {
      const { unionId } = detailInfo;
      this.$store.commit('account/setSubAccountInfo', detailInfo);
      this.$router.push(`/group/subAccount/${unionId}/detail`);
    },
    handleToAddAccount() {
      this.$router.push('/group/accountAdd');
    },
    async getSubAccountList() {
      this.loading = true;
      try {
        const res = await this.$store.dispatch('account/getSubAccountList', {
          email: this.conditionValue.email.trim(),
          memo: this.conditionValue.memo.trim(),
          pageNumber: this.dataSource.pageNumber,
          pageSize: this.dataSource.pageSize
        });
        this.dataSource.totalPages = res.totalPages;
        this.dataSource.totalItems = res.totalItems;
        this.dataSource.contents = res.contents;
      } catch {
      } finally {
        this.loading = false;
      }
    },
    async handleStatusChange(rowData) {
      try {
        const { status, unionId } = rowData;
        await this.$confirm(`确认要${status === statusEnum.Normal ? '冻结' : '解冻'}该账号吗？`);
        this.$emit('loading');
        await this.$store.dispatch('account/changeSubAccountStatus', {
          unionId,
          status: status === statusEnum.Normal ? 'FROZEN' : 'NORMAL'
        });
        this.getSubAccountList();
      } catch {
      } finally {
        this.$emit('cancelLoading');
      }
    },
    handleSearch() {
      this.dataSource.pageNumber = 1;
      this.getSubAccountList();
    },
    handlePageChange() {
      this.getSubAccountList();
    },
    openSettingDialog() {
      if (this.$refs.settingDialog) {
        this.$refs.settingDialog.$open();
      }
    },
    async  toSaveAccountSetting(settingInfo) {
      this.loading = true;
      try {
        await this.$store.dispatch('account/updateGroupUserLiveSystemSetting', {
          unionIds: this.selectUnionIds,
          params: settingInfo,
        });

        this.selectUnionIds = [];
        this.$toast.success('设置成功');
      } catch {
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.p-account-management {
  padding: 0 18px;
  .p-account-add__btn {
    margin-bottom: 20px;
  }
  .p-account-management__condition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .p-account-operate {
    &__status {
      cursor: pointer;
      color: #FF5722;
    }
    &__detail {
      cursor: pointer;
      color: #2196f3;
      margin-right: 10px;
    }
  }
  .p-account-management-table__vod {
    display: flex;
    span {
      flex: 1;
      white-space: nowrap;
      // margin-right: 8px;
    }
  }

  .p-account-management__pagination-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }

  .p-account-management__pagination-wrapper__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
</style>
